import { FC } from 'react';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { TextFileUploader } from 'src/view/components/TextFileUploader/TextFileUploader';

interface IProps {
  name: string;
  link: string;

  onUpload: (file: File) => void;
  onUnlink: (file: File) => void;
  error: string | null;
}

export const RegCertificateUpload: FC<IProps> = ({ name, link, onUpload, onUnlink, error }): JSX.Element => {
  return (
    <div className="mt-6">
      <Text text="VAT_REGISTRATION_CERTIFICATE" type={TEXT.SECTION_HEADER} />
      <TextFileUploader fileName={name} fileLinkUrl={link} wrapperClassName="mt-4" error={error} onUpload={onUpload} onUnlink={onUnlink} />
    </div>
  );
};
